import { useState, useEffect } from "react";
import { Container, Form, Button, Spinner, Nav, Navbar } from "react-bootstrap";
import { Link, useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import instance from "../../services/endpoint";
import img from "../../images/Logo.png";
import logoImg from "../../images/Logo.png";
import Loader from "../utilComponents/loader";
import { RiEyeFill, RiEyeCloseFill } from "react-icons/ri";

const AdminLogin = () => {
  const navigate = useNavigate();

  const [value, setValue] = useState({
    Email: "",
    Password: "",
  });
  const [isLoading, setIsLoading] = useState(false);
  const [loading, setLoading] = useState(false);
  const [showPassword, setShowPassword] = useState(false);
  const [errorMessage, setErrorMessage] = useState(""); // State for error message
  const [mailMsg, setMailMsg] = useState(""); // State for mail message

  const handleChange = (e) => {
    setValue({
      ...value,
      [e.target.name]: e.target.value,
    });
    setErrorMessage(""); // Clear error when user types again
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsLoading(true);
    setLoading(true);

    try {
      await instance.post("/api/v1/admin/auth/login", value);
      navigate("/admindashboard");
    } catch (error) {
      if (error?.response?.status === 403) {
        try {
          await instance.post("/api/v1/admin/auth/sendVerificationLink");
          toast.success("Verification link sent to your email!");
          setMailMsg(
            "Verification link sent to your email! Please check your email spam or inbox."
          );
        } catch (error) {
          toast.error(
            error?.response?.data?.message ||
              "Failed to send verification link."
          );
        }
      } else {
        setErrorMessage( error?.response?.data?.message || "Invalid Credentials" );
      }
    } finally {
      setIsLoading(false);
      setLoading(false);
    }
  };

  useEffect(() => {
    document.title = "Login - Bitstek Advisory";
  }, []);

  return (
    <>
      {loading && <Loader />}
      <Navbar
        expand="lg"
        style={{ background: "linear-gradient(135deg, black, #b59f5b)" }}
        className="fixed-top">
        <Container>
          <Navbar.Brand href="/homepage" className="d-flex align-items-center">
            <img
              src={logoImg}
              width="40"
              height="50"
              className="d-inline-block align-top me-2"
              alt="Logo"
            />
            <span className="fw-bold" style={{ color: "white" }}>
              Bitstek Advisory
            </span>
          </Navbar.Brand>
          <Navbar.Toggle aria-controls="basic-navbar-nav" />

          <Navbar.Collapse
            id="basic-navbar-nav"
            className="justify-content-end">
          </Navbar.Collapse>
        </Container>
      </Navbar>

      <Container
        fluid
        className="d-flex justify-content-center align-items-center"
        style={{
          minHeight: "100vh",
          background: "linear-gradient(135deg, black, #b59f5b)",
        }}>
            <div>
                <h1 className="text-center text-warning mt-5 fw-bold">
                    Admin Login
                </h1>
            </div>
        <div
          className="d-flex align-items-center "
          style={{ maxWidth: "900px", width: "100%" }}>
          {/* Image Section */}
          <div
            className="d-none d-md-block"
            style={{ flex: 1, textAlign: "center" }}>
            <iframe
              title="login-animation"
              src="https://lottie.host/embed/f6a2d287-ae1f-4b5b-a1aa-8f6737220de5/UsVVCBgXyw.lottie"
              alt="Login"
              style={{
                maxWidth: "100%",
                height: "25rem",
                width: "50rem",
                borderRadius: "10px",
                marginLeft: "-300px",
              }}></iframe>
          </div>

          {/* Login Box */}
          <div
            className="login-box"
            style={{
              backgroundColor: "#000",
              padding: "30px",
              borderRadius: "8px",
              border: "1px solid #d4af37",
              boxShadow: "0 4px 10px rgba(0, 0, 0, 0.1)",
              maxWidth: "400px",
              width: "100%",
              textAlign: "center",
              marginRight: "-115px",
            }}>
            <div className="text-center">
              <img
                src={img}
                alt="Bitstek Advisory Logo"
                style={{ width: "150px", borderRadius: "230px" }}
              />
            </div>

            <h5
              className="mb-4"
              style={{ color: "#d4af37", fontWeight: "bold" }}>
              Login to Bitstek Advisory
            </h5>

            <Form onSubmit={handleSubmit}>
              <Form.Group className="mb-3" controlId="formEmail">
                <Form.Control
                  type="email"
                  placeholder="Email"
                  name="Email"
                  value={value.Email}
                  onChange={handleChange}
                  required
                />
              </Form.Group>
              {/* password input  */}
              <Form.Group
                className="mb-3 position-relative"
                controlId="formPassword">
                <Form.Control
                  type={showPassword ? "text" : "password"}
                  placeholder="Password"
                  name="Password"
                  value={value.Password}
                  onChange={handleChange}
                  required
                  style={{ paddingRight: "40px" }}
                />
                <span
                  onClick={() => setShowPassword(!showPassword)}
                  style={{
                    position: "absolute",
                    right: "10px",
                    top: "50%",
                    transform: "translateY(-50%)",
                    cursor: "pointer",
                    fontSize: "1.5rem",
                    color: "#D4AF37",
                  }}>
                  {showPassword ? <RiEyeFill /> : <RiEyeCloseFill />}
                </span>
              </Form.Group>

              {/* Show error message below the button */}
              {errorMessage && (
                <p
                  style={{
                    color: "red",
                    fontSize: "1.1rem",
                    marginTop: "10px",
                  }}>
                  {errorMessage}
                </p>
              )}
              {mailMsg && (
                <p
                  style={{
                    color: "red",
                    fontSize: "1.1rem",
                    marginTop: "10px",
                  }}>
                  {mailMsg}
                </p>
              )}

              <div className="d-flex justify-content-between align-items-center mb-3">
                <Link
                  to="/admin/forgot-password"
                  style={{ fontSize: "0.9rem", color: "#d4af37" }}>
                  Forgot password?
                </Link>
              </div>

              <Button
                variant="warning"
                type="submit"
                className="w-100"
                disabled={isLoading}
                style={{ backgroundColor: "#d4af37", fontWeight: "bold" }}>
                {isLoading ? <Spinner animation="border" size="sm" /> : "Login"}
              </Button>
            </Form>
          </div>
        </div>
      </Container>
    </>
  );
};

export default AdminLogin;
